<template>
  <v-layout column>
    <v-layout v-if="machineName">
      <strong class="mr-2">
        Machine:
      </strong>

      {{ machineName }}
    </v-layout>

    <v-layout v-if="message">
      <strong class="mr-2">
        Message:
      </strong>

      {{ message }}
    </v-layout>

    <v-layout v-if="description">
      <strong class="mr-2">
        Description:
      </strong>

      {{ description }}
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  name: 'PbProxyNotification',

  props: {
    machineName: String,
    message: String,
    description: String,
  },
};
</script>
